import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="tbb-container py-32 text-center" data-testid="not-found-page">
      <div className="overline text-[color:var(--tbb-burgundy)] mb-4 inline-flex">404</div>
      <h1 className="font-display text-6xl uppercase mb-4">Off the menu.</h1>
      <p className="text-sm text-[color:var(--tbb-muted)] mb-8">This page doesn&apos;t exist. But your next box does.</p>
      <Link to="/" className="btn-primary">Back to Home</Link>
    </div>
  );
}
